// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__q9MhU","spinning":"Spinner_spinning__HoNId"};